import axiosInstance from '../../redux/axiosInstance';

class GeneralQuestionService {
  listQuestions(page = 1, perPage = 20) {
    return axiosInstance.get('/general-questions/list', { params: { page, perPage } });
  }

  getById(id) {
    return axiosInstance.get(`/general-questions/view/${id}`);
  }

  createQuestion(data) {
    return axiosInstance.post('/general-questions/admins/create', data);
  }

  updateQuestion(id, data) {
    return axiosInstance.patch(`/general-questions/admins/update/${id}`, data);
  }

  deleteQuestion(id) {
    return axiosInstance.delete(`/general-questions/admins/delete/${id}`);
  }
}

export default new GeneralQuestionService();
